module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gITDzEb6FAyWwAAASdJREFUKM+d07FKHFEUxvHfXE3UztgJAfMCluviYKZI5TukMJAqkkeYRtjXsBF8Aq1FRrNxMltGSCVYqNhMJSJsYFN4thR38jW3uf97z3fOd7K2ya30hqAY9JfQwxds4B1a1DjAqCrrx7bJQSZUDPrr2MM2HjHGBAnzWMQxBlVZ/26b/BkOcB8f8NfLeosr7FZlPcqi1ENsvQJOleEnvqbwtj0jKKzk2ErYCY9d9AbF9OdxR3iMPMU4Jh3hCVZTzDF1hDPcpQjA/H94Pk+RnMWO8BPOEkY4igDMWvIvnM5dn9yM1z69/4MCyzOA9/helfVNaptcVdaX+IYfcWEhmpjFuRAdvsDnqqwv2yaXTTdkpTdUDPrLEdOP2MQqbjGMh0+rsn6YbuI/tkVZaZpqf9oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/green_marker.png
// module id = 580
// module chunks = 13